import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core'

@Component({
    selector: 'sf-loading-spinner',
    template: ` @if (isLoading) {
        <div class="loading-spinner">
            <div class="loading-spinner__inner">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    style="margin: auto; display: block; shape-rendering: auto;"
                    width="200px"
                    height="200px"
                    viewBox="0 0 100 100"
                    preserveAspectRatio="xMidYMid">
                    <g transform="translate(50 50) scale(0.8)">
                        <g>
                            <animateTransform
                                attributeName="transform"
                                type="scale"
                                repeatCount="indefinite"
                                calcMode="spline"
                                dur="1s"
                                values="0.8;0.5;0.8"
                                keyTimes="0;0.5;1"
                                keySplines="0.5 0 0.5 1;0.5 0 0.5 1"></animateTransform>
                            <rect
                                x="-45"
                                y="-45"
                                width="90"
                                height="90"
                                fill="#0079a3"
                                stroke="#ffdc04"
                                stroke-width="9"
                                stroke-linejoin="round"
                                rx="1"
                                ry="1">
                                <animate
                                    attributeName="rx"
                                    repeatCount="indefinite"
                                    dur="1s"
                                    values="0;50;0"
                                    keyTimes="0;0.5;1"></animate>
                                <animate
                                    attributeName="ry"
                                    repeatCount="indefinite"
                                    dur="1s"
                                    values="0;50;0"
                                    keyTimes="0;0.5;1"></animate>
                                <animate
                                    attributeName="stroke-width"
                                    repeatCount="indefinite"
                                    dur="1s"
                                    values="9;14.4;9"
                                    keyTimes="0;0.5;1"></animate>
                                <animateTransform
                                    attributeName="transform"
                                    type="rotate"
                                    repeatCount="indefinite"
                                    dur="1s"
                                    values="0 0 0;270 0 0;540 0 0"
                                    keyTimes="0;0.5;1"
                                    calcMode="spline"
                                    keySplines="0.5 0 0.5 1;0.5 0 0.5 1"></animateTransform>
                            </rect>
                        </g>
                    </g>
                    <!-- [ldio] generated by https://loading.io/ -->
                </svg>
            </div>
        </div>
    }`,
    styleUrls: ['./loading-spinner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingSpinnerComponent {
    @Input()
    isLoading: boolean | null = false
}
